import DashboardPatientSummary from './DashboardPatientSummary'

export default DashboardPatientSummary



// WEBPACK FOOTER //
// ./src/legacy/components/DashboardPatientSummary/index.js